Fundu.Pages.Share = (function($, nv) {

    // Properties
    ///////////////////////////
    // Private Methods
    ///////////////////////////
    var selectElements = function() {
    }

    var initializeComponents = function(){

    }

    // Init
    ///////////////////////////

    var initialize = function() {
        initializeComponents();
        $(function(){
            Fundu.Components.Diagram.init();
        });

        return $.Deferred().resolve(true);
    }

    var finalize = function() {

    }

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
